import { PresenceAvailability } from "@/repository/models";

export class WrapUp {
	sessionId!: string;
	mediaId!: string;
	queueRef!: string;
	agentRef!: string;
	sipAddress!: string;
	wrapUpTimeInterval!: number;
	presence!: PresenceAvailability;
	reason!: string;
	wrapupTimerVisibility!: boolean;
	wrapUpStartDate!: string;
	defaultAssignedWrapUpCode?: WrapUpCode;
	allWrapUpCodesFromCollections?: WrapUpCode[];
	isLevelOneHidden?: boolean;
	interactionInfo?: WrapUpInteractionInfo;
	isFromCall!: boolean;
	activity!: string;
	activeVariableTextIsAiGenerated?: boolean;
	offeringVariableTextIsAiGenerated?: boolean;
	endWrapUpType?: WrapUpEndType;
}

export enum WrapUpEndType {
	ByOffering = 1,
	ByCallPickUp = 38,
}

export class WrapUpStopped {
	mediaId!: string;
	endWrapUpType?: WrapUpEndType;
}

export class WrapUpCode {
	id!: string;
	name!: string;
	level?: number;
	parentName?: string;
	collectionName?: string;
}

export class WrapUpInteractionInfo {
	name!: string;
	contactInformation!: string;
	description!: string;
}
